import { SizeBreakpoint, useStyledTheme } from '@openeducation/oe-it-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, useWindowDimensions, ViewStyle } from 'react-native';
import { IconButtonProps } from 'react-native-paper';

import { IconButton, IconName, OEText } from '../atoms';
import { fs, margin } from '../style-utils';

export type NavbarIconButtonProps = Partial<IconButtonProps> & {
  name: IconName;
  active?: boolean;
  disabled?: boolean;
  labelKey?: string;
  style?: StyleProp<ViewStyle>;
  onPress?: () => void;
};

export const NavbarIconButton = ({
  active,
  labelKey,
  style,
  ...props
}: NavbarIconButtonProps) => {
  const { t } = useTranslation();
  const { color } = useStyledTheme();
  const { width } = useWindowDimensions();

  const _color = active ? color.primary : color.dark1;

  return (
    <IconButton
      type={active ? 'solid' : 'light'}
      color={_color}
      titleAlignement={width < SizeBreakpoint.LG ? 'bottom' : 'right'}
      style={[margin(width < SizeBreakpoint.LG ? 8 : 12), style]}
      {...props}
    >
      {labelKey && width > SizeBreakpoint.MD && (
        <OEText color={_color} style={[fs(12)]}>
          {t(labelKey) as string}
        </OEText>
      )}
    </IconButton>
  );
};
